import React, { useEffect, useState } from 'react';
import { api, fmtCurrency, fmtDate } from '@/lib/api';
import { useLanguage } from '@/contexts/LanguageContext';
import { Card, CardContent } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { StatusPill } from '@/components/fintech/StatusPill';
import { Button } from '@/components/ui/button';

export default function TransactionsPage() {
  const { t } = useLanguage();
  const [items, setItems] = useState([]);
  const [type, setType] = useState('all');
  const [currency, setCurrency] = useState('all');

  const load = () => {
    const params = {};
    if (type !== 'all') params.tx_type = type;
    if (currency !== 'all') params.currency = currency;
    api.get('/wallet/transactions', { params }).then(r => setItems(r.data.items || []));
  };
  useEffect(() => { load(); }, [type, currency]);

  return (
    <div className="space-y-6">
      <h1 className="font-serif text-3xl text-[hsl(var(--brand-navy-2))]">{t('wallet.transactions')}</h1>
      <Card className="bg-white"><CardContent className="p-4">
        <div className="flex flex-wrap gap-3">
          <Select value={type} onValueChange={setType}>
            <SelectTrigger className="w-40" data-testid="transactions-status-filter"><SelectValue placeholder={t('common.type')} /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All</SelectItem>
              <SelectItem value="DEPOSIT">Deposit</SelectItem>
              <SelectItem value="WITHDRAWAL">Withdrawal</SelectItem>
              <SelectItem value="EXCHANGE">Exchange</SelectItem>
            </SelectContent>
          </Select>
          <Select value={currency} onValueChange={setCurrency}>
            <SelectTrigger className="w-40"><SelectValue placeholder={t('common.currency')} /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All</SelectItem>
              <SelectItem value="USD">USD</SelectItem>
              <SelectItem value="EUR">EUR</SelectItem>
              <SelectItem value="KMF">KMF</SelectItem>
              <SelectItem value="KZT">KZT</SelectItem>
            </SelectContent>
          </Select>
          <Button variant="ghost" onClick={load}>Refresh</Button>
        </div>
      </CardContent></Card>

      <Card className="bg-white overflow-hidden">
        <Table data-testid="transactions-table">
          <TableHeader><TableRow>
            <TableHead>{t('common.date')}</TableHead>
            <TableHead>{t('common.type')}</TableHead>
            <TableHead>{t('common.currency')}</TableHead>
            <TableHead className="text-right">{t('common.amount')}</TableHead>
            <TableHead>{t('common.status')}</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {items.length === 0 ? (
              <TableRow><TableCell colSpan={5} className="text-center py-10 text-sm text-[hsl(var(--muted-foreground))]">{t('wallet.empty')}</TableCell></TableRow>
            ) : items.map(tx => (
              <TableRow key={tx.id}>
                <TableCell className="text-xs">{fmtDate(tx.created_at)}</TableCell>
                <TableCell>{tx.type}</TableCell>
                <TableCell>{tx.currency || (tx.from_currency && `${tx.from_currency} → ${tx.to_currency}`)}</TableCell>
                <TableCell className="text-right tabular-nums">
                  {tx.type === 'EXCHANGE' ? `${fmtCurrency(tx.from_amount, tx.from_currency)} → ${fmtCurrency(tx.to_amount, tx.to_currency)}` : fmtCurrency(tx.amount, tx.currency)}
                </TableCell>
                <TableCell><StatusPill status={tx.status} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
